import React from "react";
import Sidebar from "../Sidebar/Sidebar";
import { FiArrowLeft } from "react-icons/fi";
import { Link } from "react-router-dom";
import { FiArrowUpRight } from "react-icons/fi";
import { MdOutlineEdit } from "react-icons/md";
import { RxCrossCircled } from "react-icons/rx";
import { FaArrowRight } from "react-icons/fa6";
import { HiQuestionMarkCircle } from "react-icons/hi";


const ProductDescription = () => {
  return (
    <>
      <div className="bg-[#F3F2EF] mt-14 ">
        <div className="container mx-auto py-8 gap-4 sm:px-6">
          <div className="flex px-2">
            <Sidebar />
            <div className="flex-1 mx-4">
              {/* Header */}
              <div className="flex items-center mb-3 px-2 py-4 border rounded-lg bg-white">
                <Link
                  to="/company/product-listing"
                  className="mr-2 flex items-center"
                >
                  <FiArrowLeft className="ml-1 text-xl text-gray-800" />

                  <h1 className="text-2xl font-semibold text-gray-800">
                    Applicant Tracking System
                  </h1>
                </Link>
              </div>

              {/* body */}
              <div className="border rounded-lg bg-white">
                <div className="flex items-center justify-between mb-4 p-5 border-b">
                  <p className="text-sm text-gray-500 mr-2">
                    Published by: Manish Shrimal • Last edit: 2/27/2023 by
                    Manish Shrimal
                  </p>
                  <p className="unpublished-dot text-orange-600 text-sm font-medium">
                    Unpublished
                  </p>
                </div>

                {/* product name */}
                <div className="flex items-center justify-between p-5 border-b">
                  <div className="flex items-center mb-3">
                    <div className="mr-2">
                      <img
                        src="/Images/logo/Logo-2 1old.png"
                        alt="logo"
                        className="w-12 h-12"
                      />
                    </div>
                    <div className="block">
                      <p className="font-semibold text-gray-800 text-xl">
                        Applicant Tracking System
                      </p>
                      <p className="text-md text-gray-500">
                        Recruiting Software
                      </p>
                    </div>
                  </div>
                  <div className="flex items-center space-x-3">
                    <div className="border border-gray-300 texy-gray-400 text-sm font-medium p-2 rounded-full hover:bg-blue-50">
                      <MdOutlineEdit />
                    </div>
                    <button className="border border-blue-500 text-blue-500 text-sm font-medium px-4 py-1 rounded-full hover:bg-blue-50 flex items-center">
                      Request demo <FiArrowUpRight />
                    </button>
                  </div>
                </div>

                {/* About the Product */}
                <div className="card-bg p-4 rounded-lg mb-3">
                  <div className="flex items-center mb-3">
                    <h2 className="text-lg font-semibold text-gray-800 mr-2">
                      About the product
                    </h2>
                    <div className="border border-gray-300 texy-gray-400 text-sm font-medium p-1 rounded-full hover:bg-blue-50">
                      <MdOutlineEdit />
                    </div>
                  </div>

                  <p className="text-sm text-gray-600 mb-3">
                    Our Applicant Tracking System (ATS) streamlines your
                    recruitment process by simplifying the management of job
                    applications. Whether you’re a small business or a large
                    enterprise, our ATS software helps you find the right talent
                    quickly and efficiently. With features like resume parsing,
                    candidate screening, and interview scheduling, you can
                    improve the hiring process and reduce time-to-hire. The
                    Applicant Tracking System software offers customizable
                    workflows to match your company’s needs, ensuring that every
                    step of the recruitment process is organized. With an
                    easy-to-use interface, you can track candidate progress,
                    collaborate with hiring teams, and make data-driven hiring
                    decisions.
                  </p>
                  <p className="text-sm text-gray-600 mb-3">
                    Trusted by businesses worldwide, our ATS Applicant Tracking
                    System is the key to improving recruitment efficiency and
                    ensuring you hire the best talent for your organization.
                  </p>
                  <p className="text-sm font-semibold text-gray-500 mb-3">
                    Website: <br />
                    <Link className="text-blue-500 underline">
                      https://www.logicspice.com/applicant-tracking-system
                    </Link>
                  </p>
                  <div className="mb-4">
                    <div className="flex items-center">
                      <div className="text-sm text-gray-500 mr-1 font-semibold">
                        Pricing overview
                      </div>
                      <div className="border border-gray-300 texy-gray-400 text-sm font-medium p-1 rounded-full hover:bg-blue-50">
                        <MdOutlineEdit />
                      </div>
                    </div>
                    <div className="flex items-center mt-2 space-x-4">
                      <div className="flex items-center ">
                        <RxCrossCircled />

                        <span className="text-sm text-gray-600 m-1 ">
                          No free version available
                        </span>
                      </div>
                      <div className="flex items-center">
                        <RxCrossCircled />

                        <span className="text-sm text-gray-600 m-1">
                          No free trial available
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="flex items-center space-x-2">
                    <div className="text-sm text-gray-500 font-semibold">
                      This product is intended for:
                    </div>
                    <div className="border border-gray-300 texy-gray-400 text-sm font-medium p-1 rounded-full hover:bg-blue-50">
                      <MdOutlineEdit />
                    </div>
                  </div>
                  <p className="text-sm text-gray-600">
                    Recruiter, Human Resources Director, and Recruitment
                    Consultant
                  </p>
                </div>

                {/* Product Highlights */}
                <div className="card-bg p-4 rounded-lg mb-3">
                  <h3 className="text-lg font-semibold text-gray-800 mb-2">
                    Product highlights
                  </h3>
                  <p className="text-sm text-gray-600 mb-3">
                    Feature in up to 20 posts that offer more details about your
                    product.
                  </p>
                  <button className="border border-blue-500 text-blue-500 text-sm font-medium px-4 py-1 rounded-full hover:bg-blue-50 flex items-center">
                    Manage product & highlights{ " "} <FaArrowRight />
                  </button>
                </div>

                {/* Product Videos & Screenshots */}
                <div className="card-bg p-4 rounded-lg mb-3">
                 <div className="flex items-center mb-3 space-x-2">
                  <h3 className="text-lg font-semibold text-gray-800">
                    Product videos & screenshots
                  </h3>
                    <div className="border border-gray-300 texy-gray-400 text-sm font-medium p-1 rounded-full hover:bg-blue-50">
                      <MdOutlineEdit />
                    </div>
                 </div>
                  <div className="grid grid-cols-3 gap-3">
                    <div className="border border-gray-300 border-dashed rounded p-6 flex items-center justify-center">
                      <img src="/Images/no-image.png" alt="" className="w-12 h-12" />
                    </div>
                    <div className="border border-gray-300 border-dashed rounded p-6 flex items-center justify-center">
                      <img src="/Images/no-image.png" alt="" className="w-12 h-12" />
                    </div>
                    <div className="border border-gray-300 border-dashed rounded p-6 flex items-center justify-center">
                      <img src="/Images/no-image.png" alt="" className="w-12 h-12" />
                    </div>
                  </div>
                </div>

                {/* Plans and Pricing */}
                <div className="card-bg p-4 rounded-lg mb-3">
                <div className="flex items-center mb-3 space-x-2">

                  <h3 className="text-lg font-semibold text-gray-800">
                    Plans and pricing
                  </h3>
                  <div className="border border-gray-300 texy-gray-400 text-sm font-medium p-1 rounded-full hover:bg-blue-50">
                      <MdOutlineEdit />
                    </div>
                    </div>
                  <p className="text-sm text-gray-600 mb-3">
                    Feature in up to 5 plans that helps customers learn about
                    your product’s offerings.
                  </p>
                  <div className="border border-gray-300 rounded-lg p-3">
                    <h4 className="text-sm font-semibold text-gray-800">
                      Monthly Subscription
                    </h4>
                    <div className="block">
                    <p className="text-sm font-bold text-gray-600 mt-1">
                      $45.00
                    </p>
                    <p className="text-sm text-gray-500">
                      Monthly
                    </p>
                    </div>
                    
                  </div>
                </div>

                {/* Featured Integrations */}
                <div className="card-bg p-4 rounded-lg mb-3">
                <div className="flex items-center mb-3 space-x-2">

                  <h3 className="text-lg font-semibold text-gray-800">
                    Featured integrations (0)
                  </h3>
                  <div className="border border-gray-300 texy-gray-400 text-sm font-medium p-1 rounded-full hover:bg-blue-50">
                      <MdOutlineEdit />
                    </div>
                    </div>
                  <div className="grid grid-cols-2 gap-3">
                  <div className="border border-gray-300 border-dashed rounded p-6 flex items-center justify-center">
                      <img src="/Images/features.png" alt="" className="w-12 h-12" />
                    </div>
                    <div className="border border-gray-300 border-dashed rounded p-6 flex items-center justify-center">
                      <img src="/Images/features.png" alt="" className="w-12 h-12" />
                    </div>
                  </div>
                </div>

                {/* Community Hashtags */}
                <div className="card-bg p-4 rounded-lg mb-3">
                <div className="flex items-center mb-3 space-x-2">

                  <h3 className="text-lg font-semibold text-gray-800">
                    Community hashtags
                  </h3>
                  <div className="border border-gray-300 texy-gray-400 text-sm font-medium p-1 rounded-full hover:bg-blue-50">
                  <HiQuestionMarkCircle />

                    </div>
                    </div>
                    <div className="border border-gray-300 rounded-lg p-3">
                    <p className="text-sm text-blue-500 font-semibold">#applicanttracking...</p>
                    <p className="text-sm text-gray-600 mb-2">0 followers</p>
                    </div>
                  

                </div>

                {/* Recommendations */}
                <div className=" p-4 rounded-lg">
                    <div className="border border-gray-300 p-4 rounded-lg mb-3">
                        <div className="flex items-center mb-3 space-x-2">
                            <h3 className="text-2xl font-semibold text-gray-800">
                                Recommendations
                            </h3>
                            <div className="border border-gray-300 texy-gray-400 text-sm font-medium p-1 rounded-full hover:bg-blue-50">
                            <MdOutlineEdit />
                            </div>
                        </div>
                        <div className="text-center">
                            <img src="/Images/business/company/empty.svg" alt="No Recommendations" className="mx-auto w-48 h-48"  />
                            <div className="mt-4">
                                <p className="text-xl font-semibold text-gray-900 mb-3">No visible recommendations</p>
                                <p className="text-sm text-gray-400 mb-3">
                                Your recommendations will appear here once you make them visible.
                                </p>
                                <button className="text-blue-500 text-sm font-semibold px-4 py-1 rounded hover:bg-blue-50">
                                Manage recommendations
                                </button>
                            </div>
                            
                        </div>
                        
                    </div>
                    </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProductDescription;
